/**
 * Supabase public URL cache-bust for profile avatars after upload.
 * @param {string} [url]
 */
export function profileAvatarSrc(url) {
  if (!url || typeof url !== 'string') return '';
  if (url.startsWith('blob:') || url.startsWith('data:')) return url;
  const key = url.split('/').pop()?.split('?')[0] || '1';
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}v=${encodeURIComponent(key)}`;
}
